<div class="space-y-2" *ngIf="paymentLinkUrl">
  <!-- Label -->
  <label class="block text-sm font-medium text-gray-700 mb-1">
    Link de Pago
    <span *ngIf="!isActive" class="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
      Desactivado
    </span>
    <span *ngIf="isActive" class="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
      Activo
    </span>
  </label>

  <!-- Input Container -->
  <div class="relative flex gap-2">
    <!-- Input Field -->
    <div class="flex-1 relative">
      <input
        type="text"
        [value]="paymentLinkUrl"
        [readonly]="readonly"
        [class]="getInputClasses()"
        [class.opacity-50]="!isActive"
        placeholder="Link de pago no disponible"
      />
      
      <!-- Link Icon -->
      <div class="absolute inset-y-0 right-3 flex items-center pointer-events-none">
        <i class="fas fa-link text-gray-400"></i>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="flex gap-1">
      <!-- Copy Button -->
      <button
        type="button"
        [class]="getButtonClasses()"
        class="bg-white text-blue-600 border-blue-200 hover:bg-blue-50 hover:text-blue-700 hover:border-blue-300"
        [disabled]="!isActive || !paymentLinkUrl"
        [class.opacity-50]="!isActive || !paymentLinkUrl"
        [class.cursor-not-allowed]="!isActive || !paymentLinkUrl"
        (click)="copyPaymentLink()"
        title="Copiar link al portapapeles"
      >
        <i class="fas fa-copy"></i>
        <span class="ml-1 hidden sm:inline">Copiar</span>
      </button>

      <!-- Deactivate Button -->
      <button
        type="button"
        *ngIf="showDeactivateButton && isActive"
        [class]="getButtonClasses()"
        class="bg-white text-red-600 border-red-200 hover:bg-red-50 hover:text-red-700 hover:border-red-300"
        [disabled]="!paymentLinkId"
        [class.opacity-50]="!paymentLinkId"
        [class.cursor-not-allowed]="!paymentLinkId"
        (click)="deactivatePaymentLink()"
        title="Desactivar link de pago"
      >
        <i class="fas fa-ban"></i>
        <span class="ml-1 hidden sm:inline">Desactivar</span>
      </button>

      <!-- External Link Button (for active links) -->
      <a
        *ngIf="isActive && paymentLinkUrl"
        [href]="paymentLinkUrl"
        target="_blank"
        rel="noopener noreferrer"
        [class]="getButtonClasses()"
        class="bg-white text-green-600 border-green-200 hover:bg-green-50 hover:text-green-700 hover:border-green-300"
        title="Abrir link en nueva pestaña"
      >
        <i class="fas fa-external-link-alt"></i>
        <span class="ml-1 hidden sm:inline">Abrir</span>
      </a>
    </div>
  </div>

  <!-- Help Text -->
  <p class="text-xs text-gray-500 mt-1">
    <span *ngIf="isActive">Este link permite al usuario realizar el pago de la cuota correspondiente.</span>
    <span *ngIf="!isActive">Este link ha sido desactivado y ya no es válido para realizar pagos.</span>
  </p>
</div>

<!-- Empty State -->
<div *ngIf="!paymentLinkUrl" class="text-center py-4 bg-gray-50 rounded-lg border-2 border-dashed border-gray-200">
  <i class="fas fa-link-slash text-gray-400 text-3xl mx-auto mb-2 block"></i>
  <p class="text-sm text-gray-500">No hay link de pago generado</p>
  <p class="text-xs text-gray-400 mt-1">El link aparecerá aquí cuando se genere para esta cuota</p>
</div>

<!-- Modal de Confirmación -->
<app-confirmation-modal
  [isVisible]="showConfirmationModal"
  [config]="confirmationConfig"
  (confirmed)="onConfirmDeactivation()"
  (cancelled)="onCancelDeactivation()"
  (closed)="showConfirmationModal = false">
</app-confirmation-modal>
